import Muxy, { SetupOptions } from '@muxy/extensions-js';
import { DebuggingOptions } from '@muxy/extensions-js/dist/types/src/debug';

import _Vue from 'vue';

export class VueMuxyOptions {
  // tslint:disable:variable-name
  public channel_id?: string;
  public environment?: string;
  public client_id!: string;
  public jwt?: string;
  public role?: string;
  public ua_string?: string;
  public user_id?: string;
  public url?: string;
  // tslint:enable:variable-name
}

export default function VueMuxy(
  Vue: typeof _Vue,
  options: VueMuxyOptions
): void {
  if (!options.client_id) {
    throw new Error('Must specify extension id when using the Muxy Vue plugin');
  }

  const opts = new Muxy.DebuggingOptions();
  opts.role(options.role || 'viewer');

  if (options.environment) {
    opts.environment(options.environment);
  }

  if (options.jwt) {
    opts.jwt(options.jwt);
  }

  if (options.channel_id) {
    opts.channelID(options.channel_id);
  }

  if (options.user_id) {
    opts.userID(options.user_id);
  }

  if (options.url) {
    opts.url(options.url);
  }

  const setup: SetupOptions = {
    clientID: options.client_id
  };

  if (options.ua_string) {
    setup.uaString = options.ua_string;
  }

  if (window.__VUE_MUXY_DEV_HOOK) {
    window.__VUE_MUXY_DEV_HOOK(Muxy, opts, setup);
  } else {
    Muxy.debug(opts);
    Muxy.setup(setup);
  }

  Vue.prototype.$muxy = Muxy;
}

declare module 'vue/types/vue' {
  interface Vue {
    $muxy: typeof Muxy;
  }
}

declare global {
  interface Window {
    __VUE_MUXY_DEV_HOOK: (
      muxy: typeof Muxy,
      debug: DebuggingOptions,
      setup: SetupOptions
    ) => {};
  }
}
